'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var List = _interopDefault(require('@material-ui/core/List'));
var ListItem = _interopDefault(require('@material-ui/core/ListItem'));
var SecondaryButton = require('../../buttons/SecondaryButton/SecondaryButton.js');
var StringWithPopover = require('../../StringWithPopover/StringWithPopover.js');

var pairedTableComponentGenerator = function (props) {
    var inputs = props.inputs, clickHandler = props.clickHandler, buttonValue = props.buttonValue;
    return {
        column1: (React__default.createElement(List, { dense: true, disablePadding: true }, inputs.map(function (input) { return (React__default.createElement(ListItem, { key: "" + input.dataKey, disableGutters: true },
            React__default.createElement(StringWithPopover, { strings: [input.displayKey] }))); }))),
        column2: (React__default.createElement(List, { dense: true, disablePadding: true }, inputs.map(function (input) { return (React__default.createElement(ListItem, { key: "" + input.dataKey },
            React__default.createElement(SecondaryButton, { title: buttonValue, onClick: function () { return clickHandler(input.dataKey); } }))); }))),
    };
};

module.exports = pairedTableComponentGenerator;
